// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".enter_home {\n  min-width: 1200px;\n  max-width: 1920px;\n  margin: 0 auto;\n}\n", "",{"version":3,"sources":["webpack://./src/view/websites/enter/enter.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;AACF","sourcesContent":[".enter_home {\n  min-width: 1200px;\n  max-width: 1920px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
